import { TimeMetricHandler } from '@edreamsodigeo/frontend-core';
const LOAD_PRICES_METRIC_KEY = 'LOAD_PRICES_FLIGHTS_OF2';
const METRIC_SCOPE = 'fe-shell:metric';
export const createCheckoutIntegration = ({
  storageClient
}) => {
  const loadPricesMetric = TimeMetricHandler(storageClient.get('sessionStorage'), LOAD_PRICES_METRIC_KEY, METRIC_SCOPE);
  return {
    loadPricesMetric
  };
};